import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { authApi } from '../api';
import { PageHeader, FormItem, message } from '../components/common';

const Profile = () => {
  const { user, updateUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    real_name: user?.real_name || '',
    email: user?.email || '',
    phone: user?.phone || '',
  });
  const [passwordData, setPasswordData] = useState({
    old_password: '',
    new_password: '',
    confirm_password: '',
  });

  const handleProfileUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await authApi.updateProfile(formData);
      updateUser(response.data);
      message.success('个人信息更新成功');
    } catch (err) {
      message.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    if (passwordData.new_password !== passwordData.confirm_password) {
      message.error('两次输入的密码不一致');
      return;
    }
    if (passwordData.new_password.length < 6) {
      message.error('新密码长度至少6位');
      return;
    }
    setLoading(true);
    try {
      await authApi.changePassword(passwordData.old_password, passwordData.new_password);
      message.success('密码修改成功');
      setPasswordData({ old_password: '', new_password: '', confirm_password: '' });
    } catch (err) {
      message.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const roleLabels = {
    admin: '管理员',
    developer: '开发者',
    sales: '销售'
  };

  return (
    <div className="profile-page">
      <PageHeader title="个人中心" />

      <div className="profile-card">
        <h2>基本信息</h2>
        <p><strong>用户名：</strong>{user?.username}</p>
        <p><strong>角色：</strong>{roleLabels[user?.role]}</p>
        <p><strong>创建时间：</strong>{user?.created_at ? new Date(user.created_at).toLocaleString() : '-'}</p>
      </div>

      <div className="profile-card">
        <h2>修改个人信息</h2>
        <form onSubmit={handleProfileUpdate}>
          <FormItem label="真实姓名">
            <input
              type="text"
              value={formData.real_name}
              onChange={(e) => setFormData({ ...formData, real_name: e.target.value })}
            />
          </FormItem>
          <FormItem label="邮箱">
            <input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            />
          </FormItem>
          <FormItem label="手机号">
            <input
              type="text"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
            />
          </FormItem>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            保存修改
          </button>
        </form>
      </div>

      <div className="profile-card">
        <h2>修改密码</h2>
        <form onSubmit={handlePasswordChange}>
          <FormItem label="当前密码" required>
            <input
              type="password"
              value={passwordData.old_password}
              onChange={(e) => setPasswordData({ ...passwordData, old_password: e.target.value })}
              required
            />
          </FormItem>
          <FormItem label="新密码" required>
            <input
              type="password"
              value={passwordData.new_password}
              onChange={(e) => setPasswordData({ ...passwordData, new_password: e.target.value })}
              required
            />
          </FormItem>
          <FormItem label="确认新密码" required>
            <input
              type="password"
              value={passwordData.confirm_password}
              onChange={(e) => setPasswordData({ ...passwordData, confirm_password: e.target.value })}
              required
            />
          </FormItem>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            修改密码
          </button>
        </form>
      </div>
    </div>
  );
};

export default Profile;
